import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { boardObjects } from '../../v3/boardObjects'

type BoardObjectDeleteParams = {
  boardObjectId: string
  boardId: string
  collectionId: string | null
}

type MutationParams = {
  onMutate?: (params: BoardObjectDeleteParams) => void
  onSuccess?: (data: null, params: BoardObjectDeleteParams) => void
}

type UseDeleteResult = UseMutationResult<
  null,
  unknown,
  BoardObjectDeleteParams,
  unknown
>

export function useDeleteBoardObjectMutation({
  onMutate,
  onSuccess,
}: MutationParams): UseDeleteResult {
  return useMutation({
    mutationFn: ({ boardObjectId }: BoardObjectDeleteParams) =>
      boardObjects.delete({
        path: { board_object_id: boardObjectId },
      }),
    onSuccess,
    onMutate,
  })
}
